// SHARED-011: Preload scene — load game assets with progress bar
import Phaser from 'phaser';
import { GAME_DPR, GAME_WIDTH, GAME_HEIGHT } from '../main';
import { EventBus } from '../EventBus';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PreloadScene' });
  }

  preload(): void {
    // HiDPI camera zoom
    this.cameras.main.setZoom(GAME_DPR);
    this.cameras.main.centerOn(GAME_WIDTH / 2, GAME_HEIGHT / 2);

    const barW = 300;
    const barH = 20;
    const barX = (GAME_WIDTH - barW) / 2;
    const barY = GAME_HEIGHT / 2;

    // Background bar
    const bgBar = this.add.rectangle(barX + barW / 2, barY, barW, barH, 0x222244);
    bgBar.setStrokeStyle(1, 0x4488ff);

    // Fill bar
    const fillBar = this.add.rectangle(barX + 2, barY, 0, barH - 4, 0x4488ff);
    fillBar.setOrigin(0, 0.5);

    // Loading text
    const loadText = this.add.text(GAME_WIDTH / 2, barY - 30, 'LOADING...', {
      fontSize: '16px',
      color: '#4488ff',
      fontFamily: 'monospace',
      resolution: GAME_DPR,
    }).setOrigin(0.5);

    this.load.on('progress', (value: number) => {
      fillBar.width = (barW - 4) * value;
      loadText.setText(`LOADING... ${Math.round(value * 100)}%`);
    });

    this.load.on('complete', () => {
      loadText.setText('READY');
    });

    // Battle background
    this.load.image('bg-battle', 'assets/backgrounds/bg_battle_dataspace.webp');

    // Gem tile sprites
    this.load.image('gem-red', 'assets/icons/gems/gem_red_normal.webp');
    this.load.image('gem-blue', 'assets/icons/gems/gem_blue_normal.webp');
    this.load.image('gem-green', 'assets/icons/gems/gem_green_normal.webp');
    this.load.image('gem-yellow', 'assets/icons/gems/gem_yellow_normal.webp');
    this.load.image('gem-purple', 'assets/icons/gems/gem_purple_normal.webp');
  }

  create(): void {
    EventBus.emit('boardReady');
    // Stay on this scene until a phase scene is started
  }
}
